import { IconButton, InputAdornment } from '@mui/material';
import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as EyeIcon } from 'assets/icons/eye.svg';
import { ReactComponent as EyeSlashIcon } from 'assets/icons/eyeSlash.svg';
import { Form, TextFieldController, FormGroup, PasswordController } from 'components';
import { pillFieldSx } from 'features/auth/containers/SignInForm/styles';
import { useWindowSize } from 'hooks';
import { passwordRules, required } from 'validations';

import { CreatePasswordButton, hintsSx } from './styles';
import { useCreatePasswordForm } from './useCreatePasswordForm';

export function CreatePasswordForm(): ReactElement {
  const { isMobile } = useWindowSize();
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);

  const { control, handleFormSubmit, validatePasswords } = useCreatePasswordForm();

  return (
    <Form sx={{ marginTop: isMobile ? '32px' : '56px' }} onSubmit={handleFormSubmit}>
      <FormGroup marginBottom={32}>
        <PasswordController
          name="password"
          id="password"
          control={control}
          label={t('createPassword.password')}
          placeholder={t('createPassword.password')}
          rules={passwordRules}
          maxLength={60}
          hintsSx={hintsSx}
          sx={pillFieldSx}
          withAdornment
        />
      </FormGroup>
      <FormGroup marginBottom={32}>
        <TextFieldController
          name="repeatPassword"
          id="repeatPassword"
          control={control}
          type={showPassword ? 'text' : 'password'}
          label={t('createPassword.passwordRepeat')}
          placeholder={t('createPassword.passwordRepeat')}
          maxLength={60}
          onBlur={validatePasswords}
          rules={required}
          sx={pillFieldSx}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label={t('login.form.togglePasswordVisibility')}
                  onClick={() => setShowPassword((show) => !show)}
                  edge="end"
                >
                  {showPassword ? <EyeIcon /> : <EyeSlashIcon />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </FormGroup>

      <CreatePasswordButton type="submit" variant="contained" color="info">
        {t('createPassword.changePasswordButton')}
      </CreatePasswordButton>
    </Form>
  );
}
